/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityDiscountResponseDto {
    type?: ActivityDiscountResponseDto.TypeEnum;
    name?: string;
    amount?: number;
}
export namespace ActivityDiscountResponseDto {
    export const TypeEnum = {
        Promotion: 'PROMOTION',
        LoyaltyDiscount: 'LOYALTY_DISCOUNT',
        VolumeDiscount: 'VOLUME_DISCOUNT',
        TimeDiscount: 'TIME_DISCOUNT',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
